import { useState } from 'react';
import { Modal, ModalBody, Button, Stack } from '@7shifts/sous-chef-base';
import type { ClockDepartment } from '@src/api/punchTypes';
import { useTranslation } from '@src/i18n';
import { PickerList, PickerCell } from './PickerCell';

interface OfflineDepartmentSelectionModalProps {
    departments: ClockDepartment[];
    onSelect: (departmentId: number) => void;
    onCancel: () => void;
}

export function OfflineDepartmentSelectionModal({
    departments,
    onSelect,
    onCancel
}: OfflineDepartmentSelectionModalProps) {
    const [submitted, setSubmitted] = useState(false);
    const { t } = useTranslation();

    function handleSelect(departmentId: number) {
        if (submitted) return;
        setSubmitted(true);
        onSelect(departmentId);
    }

    return (
        <Modal
            header={t('department.title')}
            testId="offline-department-selection-modal"
        >
            <ModalBody>
                <Stack space={16}>
                    <PickerList testId="offline-department-list">
                        {departments.map(department => (
                            <PickerCell
                                key={department.id}
                                label={department.name}
                                disabled={submitted}
                                onSelect={() => handleSelect(department.id)}
                                testId={`offline-department-selection-${department.id}`}
                            />
                        ))}
                    </PickerList>
                    <Button
                        type="button"
                        theme="hollow"
                        size="full-width"
                        disabled={submitted}
                        onClick={onCancel}
                        testId="offline-department-selection-cancel"
                    >
                        {t('common.cancel')}
                    </Button>
                </Stack>
            </ModalBody>
        </Modal>
    );
}
